import {SampleDetails} from 'constants/SampleConstants';
import {
  isTypeInSampleFilters,
  SampleFilter,
  SampleFilterType,
} from 'notebook/sample-propagation/SampleFilter';

/**
 * This tool allows you to ensure that a list of samples only has samples of the provided type(s).
 * Intended for use as part of an Array.filter call.
 *
 * E.g.:
 *    const bioentityOnlyFilter = [SimpleSampleFilters.BIOENTITY];
 *    const filteredSamples = allBatchSamples.filter((sample) => filterSample(sample, bioentityOnlyFilter));
 *    assert(filteredSamples.length === 0);
 *
 * Filters are OR.
 */
export default function filterSample(sample: SampleDetails, limitSamplesTo: Array<SampleFilter>): boolean {
  return (
    (sample.batchInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.BATCH)) ||
    (sample.bioentityInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.BIOENTITY)) ||
    (sample.boxInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.BOX)) ||
    (sample.plateInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.PLATE)) ||
    (sample.containerInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.CONTAINER)) ||
    (sample.numberInfo != null &&
      sample.numberInfo.isFloat &&
      isTypeInSampleFilters(limitSamplesTo, SampleFilterType.FLOAT)) ||
    (sample.numberInfo != null &&
      !sample.numberInfo.isFloat &&
      isTypeInSampleFilters(limitSamplesTo, SampleFilterType.INTEGER)) ||
    (sample.textInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.STRING)) ||
    (sample.booleanInfo != null && isTypeInSampleFilters(limitSamplesTo, SampleFilterType.BOOLEAN))
  );
}
